export enum FacilityStatus {
  Active = 0,
  Inactive = 1,
  Suspended = 2,
  PendingApproval = 3,
  Rejected = 4,
}
